import { ApiQuoteAddress, QuoteAddress, ApiServiceType } from "Types"

export const parseAddress = (data: ApiQuoteAddress): QuoteAddress => {
  return {
    id: data.id,
    description: data.description,
    isCompanyAddress: data.isCompanyAddress,
    street: data.street,
    streetNumber: data.streetNumber,
    streetDetails: data.complementary,
    neighborhood: data.neighborhood,
    zipcode: data.zipcode.replace('-', ''),
    city: data.city,
    uf: data.uf,
  }
}

export const parseAddressList = (data: ApiQuoteAddress[]): QuoteAddress[] => {
  return data.map(parseAddress)
}


export const parseQuotationService = (service: ApiServiceType) => ({
  id: service.id,
  name: service.name,
  slug: service.slug,
})

export default {
  parseAddress,
  parseAddressList,
}